import React, { useState, useContext, useEffect } from "react";
import { UserInformationContext, C4FStatusContext, ReferenceDataContext } from "../main/App";
import { Row, Col, Button, Container } from 'react-bootstrap';
import '../css/general.css';
import C4FSimpleTable from "../common/C4FSimpleTable";

function Notifications(props) {

  const { userInformation, setUserInformation } = useContext(UserInformationContext);
  const { handleBackendRequest, raiseError } = useContext(C4FStatusContext);
  const { notificationTypes } = useContext(ReferenceDataContext);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [notifications, setNotifications] = useState(null);

  function prepareNotification(notification) {
    // find notification in reference data by type
    if (!notificationTypes.some(nt => nt.type === notification.type)) {
      raiseError('Technical Error', 0, 'Notification type ' + notification.type + ' not found in reference data');
      return notification;
    }
    let notificationDefinition = notificationTypes.find(nt => nt.type === notification.type);
    if (notificationDefinition.parameters.some(ntp =>
      ntp !== 'recipient' && ntp !== 'recipientId' && !notification.parameters.some(mp => mp.name === ntp))) {
      raiseError('Technical Error', 0,
        'Parameter ' +
        notificationDefinition.parameters.find(ntp =>
          ntp !== 'recipient' && ntp !== 'recipientId' && !notification.parameters.some(mp => mp.name === ntp))
        + ' missing from notification '
        + notification.type);
      return notification;
    }

    let notificationSubject = notificationDefinition.subject;
    let notificationContent = notificationDefinition.notification;

    // search replace recipientId and recipient
    notificationSubject = notificationSubject
      .replaceAll('${recipientId}', userInformation.userID)
      .replaceAll('${recipient}', userInformation.userName);
    notificationContent = notificationContent
      .replaceAll('${recipientId}', userInformation.userID)
      .replaceAll('${recipient}', userInformation.userName);

    // search and replace the rest
    notification.parameters
      .filter(p => p.name !== 'recipient' && p.name !== 'recipientId')
      .forEach(p => {
        notificationSubject = notificationSubject.replaceAll('${' + p.name + '}', p.value);
        notificationContent = notificationContent.replaceAll('${' + p.name + '}', p.value);
      })

    return {
      ...notification,
      subject: notificationSubject,
      content: notificationContent
    }

  }

  function refreshNotifications() {
    setNotifications(null);
    handleBackendRequest('GET', '/user/' + userInformation.userName + '/notification', null, null,
      function (result) {
        setUserInformation({ ...userInformation, notifications: result });
      });
  }

  function loadAllNotifications() {
    setNotifications(null);
    handleBackendRequest('GET', '/user/' + userInformation.userName + '/notification', null, { context: 'all' },
      function (result) {
        let notifications = result.map(n => prepareNotification(n));
        setNotifications(notifications);
      });
  }

  function handleSetSelectedNotification(notification) {
    if (notification.status === 'Unread')
      setNotificationStatus(notification.id, 'Read');
    else
      setSelectedNotification(notification);
  }

  function setNotificationStatus(id, status) {
    handleBackendRequest('PATCH', '/user/' + userInformation.userName + '/notification/' + id, null, { key: 'status', value: status },
      function (notification) {
        setSelectedNotification(prepareNotification(notification));
      });
  }

  useEffect(() => {
    if ('notifications' in userInformation)
      setNotifications(userInformation.notifications.map(n => prepareNotification(n)));
  }, []);

  useEffect(() => {
    if ('notifications' in userInformation)
      setNotifications(userInformation.notifications.map(n => prepareNotification(n)));
  }, [userInformation]);


  return <Container fluid className="m-1">
    <Row className="row d-flex c4f-stats p-1">
      <Col>
        <h5>Messages</h5>
        <p>On this page you can find system-generated messages informing you about various important topics like revoked nationalities of your riders or open fairplay cases you're involved in. You can archive the messages after reading or look into archived messages again by using the corresponding buttons below.</p>
        {notifications !== null ?
          <C4FSimpleTable key={'notifications'}
            initialSortingColumn={'created'}
            initialSortingAscending={false}
            highlightCriteriaKey={'id'}
            highlightCriteriaValue={selectedNotification !== null ? selectedNotification.id : null}
            data={notifications}
            hideColumnVisibility={true}
            rowMetadata={[
              { columnName: 'created', columnDescription: 'Date' },
              { columnName: 'subject', columnDescription: 'Subject', cellClickEvent: handleSetSelectedNotification },
              { columnName: 'status', columnDescription: 'Status' }
            ]}
          />
          : null}
      </Col>
    </Row>
    {selectedNotification !== null ?
      <>
        <Row className="row d-flex p-1">
          <Col className="col-3" />
          <Col className="col-6">
            <h5>{selectedNotification.subject}</h5>
            <p>{selectedNotification.content}</p>
            <Button disabled={selectedNotification.status === 'Archived'}
              variant={(selectedNotification.status === 'Archived' ? 'outline-' : '') + 'secondary'}
              onClick={() => setNotificationStatus(selectedNotification.id, 'Archived')}>Archive Message</Button>
          </Col>
          <Col className="col-3" />
        </Row>
      </>
      : null}
    <Row className="row d-flex p-1">
      <Col className="col-3" />
      <Col className="col-6">
        <Button variant={'secondary'} onClick={() => refreshNotifications()}>Refresh Messages</Button>
        <Button className="mx-2" variant={'secondary'} onClick={() => loadAllNotifications()}>Load Archived Messages</Button>
      </Col>
      <Col className="col-3" />
    </Row>
  </Container >;
}

export default Notifications;
